module.exports = __webpack_public_path__ + "static/media/to-label.2a636b2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/to-label.svg
// module id = 817
// module chunks = 0